import { RootState } from 'store';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { ResourceListSelectors, StateResource } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors((state: RootState): StateResource => state.owner);

export default selectors;
